import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useRatePlan} from '../hooks/useRatePlan.ts';
import {useRatePlansSelection} from '../hooks/useRatePlansSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {useRatePlans} from "../hooks/useRatePlans.ts";


export const EditPage = () => {

    const {id: ratePlansId} = useParams();

    if (typeof ratePlansId === 'undefined') {
        throw new Error('ratePlansId is required parameter');
    }

    const {fetchRecords} = useRatePlans();

    const {
        record: ratePlans,
        fetchRecord,
        updateRecord,
    } = useRatePlan(ratePlansId);

    const {handleClearSelection} = useRatePlansSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);

    useEffect(() => {
        fetchRecords();
    }, []);

    useEffect(() => {
        fetchRecord();
    }, [ratePlansId]);

    if (!ratePlans) {
        return <PlatformLoader message='Loading Rate Plans...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={ratePlans.name ? ratePlans.name : ratePlans.id}
            pageNavigation={<EditPageNavigation component={ratePlans}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={ratePlans}
                    />

                    {/*
                    <AccountsPage/>
                    */}

                </Stack>
                :
                <RecordForm
                    record={ratePlans}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};
